<template>
  <b-row class="match-height m-2">
    <b-col cols="12">
      <b-form>
        <b-form-group
          label="Bộ lọc"
          class="border border-primary rounded p-50"
          label-class="pb-25"
        >
          <b-row>
            <b-col cols="4">
              <v-select
                v-model="filter.trainingSystemId"
                :options="trainingSystems"
                :reduce="option => option.value"
                placeholder="Hệ đào tạo"
                @input="onTrainingSystemsChange"
              />
            </b-col>
            <b-col cols="4">
              <v-select
                v-model="filter.courseId"
                title="Khóa học"
                :options="courses"
                :reduce="option => option.value"
                placeholder="Khóa học"
                @input="onCoursesChange"
              />
            </b-col>
            <b-col cols="4">
              <v-select
                v-model="filter.courseSemesterId"
                :options="courseSemesters"
                :reduce="option => option.value"
                placeholder="Học kỳ"
              />
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col cols="">
              <v-select
                v-model="filter.majorId"
                :options="majors"
                :reduce="option => option.value"
                placeholder="Ngành học"
                @input="onMajorChange"
              />
            </b-col>
            <b-col cols="4">
              <v-select
                v-model="filter.programmeId"
                :options="programmes"
                :reduce="option => option.value"
                placeholder="Chương trình đào tạo"
                @input="onProgrammeChange"
              />
            </b-col>
            <b-col cols="4">
              <v-select
                v-model="filter.classId"
                :options="classes"
                :reduce="option => option.value"
                placeholder="Lớp"
                @input="onClassChange"
              />
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="12">
              <b-button
                variant="success"
                class="mr-1"
                @click="btnSearchClick"
              >
                <feather-icon icon="SearchIcon" /> Tìm kiếm
              </b-button>
              <b-button
                variant="success"
                class="mr-1"
                @click="btnExportClick"
              >
                <feather-icon icon="FileTextIcon" /> Xuất báo cáo
              </b-button>
              <b-button
                v-if="creatable"
                variant="primary"
                class="ml-1"
                @click="onCreate"
              >
                <feather-icon icon="PlusIcon" /> Thêm
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </b-col>
    <b-col cols="12">
      <vue-good-table
        style-class="vgt-table striped bordered"
        class="my-table"
        :columns="fields"
        :rows="itemsDisplay"
        :line-numbers="true"
        mode="remote"
        :pagination-options="{ enabled: true }"
        :total-rows="totalRecords"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-per-page-change="onPerPageChange"
      >

        <div
          slot="emptystate"
          style="text-align:center;font-weight:bold"
        >
          Không có dữ liệu
        </div>

        <template
          slot="table-row"
          slot-scope="props"
        >

          <span v-if="props.column.field === 'studyDate'">
            {{ formatDate(props.row.studyDate) }}
          </span>

          <span v-else-if="props.column.field === 'subjectName'">
            [{{ props.row.subjectCode }}] {{ props.row.subjectName }}
          </span>

          <span v-else-if="props.column.field === 'lessonContent'">
            <div style="max-width:300px">
              {{ props.row.lessonContent }}
            </div>
          </span>

          <!-- action -->
          <span v-else-if="props.column.field === 'action'">
            <b-button-group>

              <!-- edit -->
              <b-button
                v-if="updatable"
                variant="primary"
                size="sm"
                class="btn-icon"
                @click="onEdit(props.row)"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>

              <!-- delete -->
              <b-button
                v-if="deletable && props.row.lessonLogId"
                variant="danger"
                size="sm"
                class="btn-icon"
                @click="onDelete(props.row)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>

            </b-button-group>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>

        </template>

      </vue-good-table>
      <b-modal
        id="lessonLogCreateModal"
        title="Thêm sổ đầu bài"
        centered
        @ok="onSubmitCreate"
      >

        <b-form>

          <b-form-group label="Học phần">

            <v-select
              v-model="currentLessonLog.creditClassId"
              :options="creditClasses"
              :reduce="o=>o.creditClassId"
              label="subjectName"
            />

          </b-form-group>

          <b-form-group label="Ngày học">

            <b-form-input
              v-model="currentLessonLog.studyDate"
              type="date"
            />

          </b-form-group>

          <b-form-group label="Lý thuyết">

            <b-form-input
              v-model="currentLessonLog.theoryHours"
              type="number"
              min="0"
            />

          </b-form-group>

          <b-form-group label="Thực hành">

            <b-form-input
              v-model="currentLessonLog.practiceHours"
              type="number"
              min="0"
            />

          </b-form-group>

          <b-form-group label="Kiểm tra">

            <b-form-input
              v-model="currentLessonLog.examHours"
              type="number"
              min="0"
            />

          </b-form-group>

          <b-form-group label="Vắng">

            <b-form-input
              v-model="currentLessonLog.absentStudentCount"
              type="number"
              min="0"
            />

          </b-form-group>

          <b-form-group label="Nội dung">

            <b-form-textarea
              v-model="currentLessonLog.lessonContent"
            />

          </b-form-group>

        </b-form>

      </b-modal>
      <b-modal
        v-if="currentLessonLog"
        id="lessonLogEditModal"
        title="Cập nhật sổ đầu bài"
        centered
        @ok="onSubmitEdit"
      >

        <b-form>

          <b-form-group label="Lý thuyết">
            <b-form-input
              v-model="currentLessonLog.theoryHours"
              type="number"
              min="0"
            />
          </b-form-group>

          <b-form-group label="Thực hành">
            <b-form-input
              v-model="currentLessonLog.practiceHours"
              type="number"
              min="0"
            />
          </b-form-group>

          <b-form-group label="Kiểm tra">
            <b-form-input
              v-model="currentLessonLog.examHours"
              type="number"
              min="0"
            />
          </b-form-group>

          <b-form-group label="Số sinh viên vắng">
            <b-form-input
              v-model="currentLessonLog.absentStudentCount"
              type="number"
              min="0"
            />
          </b-form-group>

          <b-form-group label="Nội dung">
            <b-form-textarea
              v-model="currentLessonLog.lessonContent"
              rows="3"
            />
          </b-form-group>

        </b-form>

      </b-modal>
    </b-col>
    <b-row />
  </b-row>
</template>
<script>

import {
  BFormInput, BFormTextarea, BButton, BButtonGroup, BCol, BForm, BFormGroup, BRow,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { VueGoodTable } from 'vue-good-table'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import { getUser } from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { hasPermissionForResource, isSystemAdmin } from '@/utils';
import { PermissionCode, ResourceCode } from '@/const/code';

export default {
  directives: {
    Ripple,
  },
  components: {
    BFormInput,
    BFormTextarea,
    BButton,
    BButtonGroup,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    vSelect,
    VueGoodTable,
  },
  data() {
    return {
      user: getUser(),

      filter: {
        organizationId: null,
        trainingSystemId: null,
        courseId: null,
        courseSemesterId: null,
        majorId: null,
        programmeId: null,
        classId: null,
      },

      currentLessonLog: {
        creditClassId: null,
        studyDate: null,
        lessonLogId: null,
        theoryHours: 0,
        practiceHours: 0,
        examHours: 0,
        lessonContent: '',
        absentStudentCount: 0,
      },

      serverParams: {
        columnFilters: {},
        sort: [{ field: '', type: '' }],
        page: 1,
        perPage: 10,
      },

      items: [],
      itemsDisplay: [],
      totalRecords: 0,
      fields: [
        {
          field: 'studyDate',
          label: 'Ngày học',
          thClass: 'text-center',
          sortable: false,
        },
        {
          field: 'subjectName',
          label: 'Học phần',
          thClass: 'text-center',
          sortable: false,
        },
        {
          field: 'theoryHours',
          label: 'Lý thuyết',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          field: 'practiceHours',
          label: 'Thực hành',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          field: 'examHours',
          label: 'Kiểm tra',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          field: 'absentStudentCount',
          label: 'Vắng',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          field: 'action',
          label: '',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      trainingSystems: 'dropdown/trainingSystems',
      courses: 'dropdown/courses',
      courseSemesters: 'dropdown/courseSemesters',
      majors: 'dropdown/majors',
      programmes: 'dropdown/programmes',
      classes: 'dropdown/classes',
      lessonLogs: 'lessonLog/lessonLogs',
      total: 'lessonLog/total',
      creditClasses: 'lessonLog/creditClasses',
    }),
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.CLASS_REGISTER)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.CLASS_REGISTER)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.CLASS_REGISTER)
    },
  },
  async created() {
    await this.getDataFromStore()
  },
  methods: {
    ...mapActions({
      exportWord: 'lessonLog/exportWord',
      getCourses: 'dropdown/getCourses',
      getCourseSemesters: 'dropdown/getCourseSemesters',
      getTrainingSystems: 'dropdown/getTrainingSystems',
      getDepartments: 'dropdown/getDepartments',
      getMajors: 'dropdown/getMajors',
      getProgrammes: 'dropdown/getProgrammes',
      getClasses: 'dropdown/getClasses',
      getSchoolYears: 'dropdown/getSchoolYears',
      getLessonLogs: 'lessonLog/readLessonLogs',
      getTeacherCreditClasses: 'lessonLog/getTeacherCreditClasses',
      createLessonLog: 'lessonLog/createLessonLog',
      deleteLessonLog: 'lessonLog/deleteLessonLog',
      updateLessonLog: 'lessonLog/updateLessonLog',
    }),
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString('vi-VN')
    },
    async getDataFromStore() {
      this.filter.organizationId = this.user.orgId
      await Promise.all([
        this.getTrainingSystems({ organizationId: this.filter.organizationId }),
        this.getDepartments({ organizationId: this.filter.organizationId }),
        this.getSchoolYears({}),
      ])

      if (this.trainingSystems.length > 0) {
        this.filter.trainingSystemId = this.trainingSystems[0].value
        await this.onTrainingSystemsChange(this.filter.trainingSystemId)
      }
    },
    async onTrainingSystemsChange(event) {
      this.filter.trainingSystemId = event
      this.filter.courseId = null

      await this.getCourses({
        trainingSystemId: this.filter.trainingSystemId,
      })

      // chọn mặc định course đầu tiên
      if (this.courses.length > 0) {
        this.filter.courseId = this.courses[0].value
      }

      await this.onCoursesChange(this.filter.courseId)
    },
    async onCoursesChange(event) {
      this.filter.courseId = event
      this.filter.courseSemesterId = null
      const request = { ...this.filter }
      delete request.itemsPerPage
      await Promise.all([
        this.getCourseSemesters({ organizationId: getUser().orgId, courseId: this.filter.courseId, status: null }),
        this.getMajors(request),
        this.getProgrammes(request),
      ])
      if (this.courseSemesters.length > 0) {
        this.filter.courseSemesterId = this.courseSemesters[0].value
      }
      if (this.majors.length > 0) {
        this.filter.majorId = this.majors[0].value
      }
      await this.onMajorChange(this.filter.majorId)
    },
    async onMajorChange(event) {
      this.filter.majorId = event
      this.filter.programmeId = null
      this.filter.classId = null
      await this.getProgrammes(this.filter)
      if (event !== null) {
        if (this.programmes.length > 0) {
          this.filter.programmeId = this.programmes[0].value
        }
      }
      await this.onProgrammeChange(this.filter.programmeId)
    },
    async onProgrammeChange(event) {
      this.filter.programmeId = event
      this.filter.classId = null
      await this.getClasses({
        organizationId: getUser().orgId,
        trainingSystemId: this.filter.trainingSystemId,
        courseId: this.filter.courseId,
        majorId: this.filter.majorId,
        programmeId: this.filter.programmeId,
      })
      if (this.classes.length > 0) {
        this.filter.classId = this.classes[0].value
      }
      await this.getData()
    },
    async btnExportClick() {
      await this.exportWord(this.filter)
    },
    async btnSearchClick() {
      await this.getData(this.filter)
    },
    async onClassChange(event) {
      this.filter.classId = event

      if (!event) return

      await this.getData()
    },
    async getData() {
      if (!this.filter.classId) return

      await this.getLessonLogs({
        classId: this.filter.classId,
        courseSemesterId: this.filter.courseSemesterId,
        currentPage: this.serverParams.page,
        itemsPerPage: this.serverParams.perPage,
      })

      this.items = this.lessonLogs
      this.itemsDisplay = [...this.items]
      this.totalRecords = this.total
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },

    async onPageChange(param) {
      this.updateParams({ page: param.currentPage })
      await this.getData()
    },

    async onPerPageChange(param) {
      this.updateParams({
        page: 1,
        perPage: param.currentPerPage,
      })
      await this.getData()
    },

    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]

        this.updateParams({
          sort: [{ field, type }],
        })
      }

      await this.getData()
    },
    async onCreate() {
      await this.getTeacherCreditClasses({
        classId: this.filter.classId,
        courseSemesterId: this.filter.courseSemesterId,
      })

      this.currentLessonLog = {
        creditClassId: null,
        studyDate: null,
        theoryHours: 0,
        practiceHours: 0,
        examHours: 0,
        lessonContent: '',
        absentStudentCount: 0,
      }

      this.$bvModal.show('lessonLogCreateModal')
    },
    async onSubmitCreate() {
      const res = await this.createLessonLog(this.currentLessonLog)
      if (res && res.isSuccessful) {
        this.showToast(res.message || 'Thêm sổ đầu bài thành công')
        await this.getData()
      } else {
        this.showToast(res?.message || 'Thêm thất bại', 'danger')
      }

      await this.getData()
    },

    onEdit(row) {
      this.currentLessonLog = {

        lessonLogId: row.lessonLogId,
        creditClassId: row.creditClassId,
        studyDate: row.studyDate,
        theoryHours: row.theoryHours,
        practiceHours: row.practiceHours,
        examHours: row.examHours,
        lessonContent: row.lessonContent,
        absentStudentCount: row.absentStudentCount,
      }

      this.$bvModal.show('lessonLogEditModal')
    },
    async onSubmitEdit() {
      const res = await this.updateLessonLog({
        lessonLogId: this.currentLessonLog.lessonLogId,
        theoryHours: this.currentLessonLog.theoryHours,
        practiceHours: this.currentLessonLog.practiceHours,
        examHours: this.currentLessonLog.examHours,
        lessonContent: this.currentLessonLog.lessonContent,
        absentStudentCount: this.currentLessonLog.absentStudentCount,
      })

      if (res && res.isSuccessful) {
        this.showToast(res.message || 'Cập nhật sổ đầu bài thành công')
        await this.getData()
      } else {
        this.showToast(res?.message || 'Cập nhật thất bại', 'danger')
      }

      await this.getData()
    },
    async onDelete(row) {
      this.$swal({
        title: 'Xóa sổ đầu bài?',
        text: 'Bạn sẽ không thể khôi phục!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
      }).then(async result => {
        if (result.value) {
          await this.deleteLessonLog(row.lessonLogId)
          this.showToast('Xóa sổ đầu bài thành công')
          await this.getData()
        }
      })
    },
    showToast(message, variant = 'success') {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: variant === 'success' ? 'CheckIcon' : 'XCircleIcon',
          variant,
        },
      })
    },
  },
}
</script>
<style>
.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement="top"] {
  border-radius: 4px 4px 0 0;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
